import { render, staticRenderFns } from "./age.vue?vue&type=template&id=ff85547c&scoped=true"
import script from "./age.vue?vue&type=script&lang=js"
export * from "./age.vue?vue&type=script&lang=js"
import style0 from "./age.vue?vue&type=style&index=0&id=ff85547c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff85547c",
  null
  
)

export default component.exports